//Library
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import md5 from 'md5';
import Swal from 'sweetalert2';
import { isMobile } from 'react-device-detect';
import QS from 'query-string';
import { pushUserIdToDataLayer } from '../../utils/analytics.js';

//redux
import { connect } from 'react-redux';
import { loginApi, updatePwd, ChkAccessTkn } from '../../action/anueInfoAction';
import Cookies from 'universal-cookie';
//config
import config from '../../config';

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentWillMount() {
    document.documentElement.scrollTop = 0;
    const cookies = new Cookies();
    if(cookies.get('anueFundToken')===undefined){

    } else {
      //alert(Object.keys(cookies.get('anueFundToken')));
      var tokenobj = cookies.get('anueFundToken');
      this.props.ChkAccessTkn(tokenobj, (response) => {
        if(response) 
          {
            pushUserIdToDataLayer();  //登入
            this.props.history.push("/Purchase");
          }
      });
    }
  }

  loginSubmit() {
    let custID = document.getElementById("custID").value;
    let userID = document.getElementById("userID").value;
    let pwd = document.getElementById("password").value;
    if (custID === undefined || custID === null || custID === '') {
      Swal.fire("請輸入身分證字號。");
      return;
    } else if (userID === undefined || userID === null || userID === '') {
      Swal.fire("使用者代號。");
      return;
    }else if (pwd === undefined || pwd === null || pwd === '') {
      Swal.fire("請輸入密碼。");
      return;
    } else {
      let data = {
            UserID: custID,
            MD5UserID: md5(userID),
            MD5Password: md5(pwd)
          }
      this.props.loginApi(data, (response) => {
        if(response.code === "01013"){
          Swal.fire({
            type: 'info',
            text: "您的密碼超過一年未變更!",
            showCancelButton: true,
            confirmButtonText: "前往變更密碼",
            cancelButtonText: "沿用舊密碼",
            allowOutsideClick: false
          }).then((res)=>{
            if(res.value){
              window.location.href = "../../EC/member/change-password";
            } else {
              this.props.updatePwd(data, (response) => {
              });
              setTimeout(()=>{
                this.goNext();
              },500);
            }
          });
        } else if(response.code === "01005"){
          Swal.fire({
            type: 'info',
            text: "您的初始密碼尚未變更!",
            confirmButtonText: "前往變更密碼",
            allowOutsideClick: false
          }).then(()=>{
            window.location.href = "../../EC/member/change-password";
          });
        } else {
          this.goNext()
        }
      });
    }
  }

  markCustID(){
    if(document.getElementById("custID").type === "text"){
      document.getElementById("custID").type = "password";
      document.getElementById("custID_mark").className = "fa-solid fa-eye-slash";
    } else {
      document.getElementById("custID").type = "text";
      document.getElementById("custID_mark").className = "fa-solid fa-eye";
    }
    
  }

  markUserID(){
    if(document.getElementById("userID").type === "text"){
      document.getElementById("userID").type = "password";
      document.getElementById("userID_mark").className = "fa-solid fa-eye-slash";
    } else {
      document.getElementById("userID").type = "text";
      document.getElementById("userID_mark").className = "fa-solid fa-eye";
    }
    
  }

  markPassword(){
    if(document.getElementById("password").type === "text"){
      document.getElementById("password").type = "password";
      document.getElementById("password_mark").className = "fa-solid fa-eye-slash";
    } else {
      document.getElementById("password").type = "text";
      document.getElementById("password_mark").className = "fa-solid fa-eye";
    }
    
  }

  goNext(){
    const parsed = QS.parse(this.props.location.search.toLowerCase());
    if (parsed.to !== undefined) {
      switch (parsed.to) {
        case "tsr":
          //轉換好像廢掉了
          if (parsed.sid !== undefined && parsed.fundid !== undefined) {
            this.props.history.push({ pathname: "/TSR", search: "?sid=" + parsed.sid + "&fundid=" + parsed.fundid.toUpperCase() });
          } else {
            this.props.history.push("/index");
          }
          break;
        default:
          this.props.history.push("/Purchase");
          //含小網登入
          //window.location.href = config.loginPath + "/LoginRedirct.aspx?redir=/EC/GoodDay/Purchase";
      }
    } else {
      this.props.history.push("/Purchase");
      //含小網登入
      //window.location.href = config.loginPath + "/LoginRedirct.aspx?redir=/EC/GoodDay/Purchase";
    }
  }

  render() {
    return <div style={{ overflowX: "hidden" }}>
      <div className="banner login">
        <div className="anueContainer">
          <div className="sizeBox">
          </div>
          <div className="loginContainer">
            <div>
              <h1 className="title" alt="【好日子】─ anuefund鉅亨買基金"><span></span></h1>
            </div>
            <div>
              <div className="loginBox featureBox">
                <div className="tag">交易登入</div>
                <div className="calFlexbox">
                  <div className="inputGroup" style={{position:"relative"}}>
                    <label>身份證字號</label>
                    <input className="form-control form-control-sm" type="text" id="custID" placeholder="請輸入身份證字號" />
                    <i id="custID_mark" style={{position: "absolute", top:"40px",right: "0px"}} class="fa-solid fa-eye" onClick={() => { this.markCustID() }}></i>
                  </div>
                </div>
                <div className="calFlexbox" style={{position:"relative"}}>
                  <div className="inputGroup">
                    <label>交易密碼</label>
                    <input className="form-control form-control-sm" type="password" id="password" placeholder="請輸入交易密碼" />
                    <i id="password_mark" style={{position: "absolute", top:"40px",right: "0px"}} class="fa-solid fa-eye-slash" onClick={() => { this.markPassword() }}></i>
                  </div>
                </div>
                <div className="calFlexbox" style={{position:"relative"}}>
                  <div className="inputGroup">
                    <label>使用者代號</label>
                    <input className="form-control form-control-sm" type="text" id="userID" placeholder="初始為西元生日八碼" />
                    <i id="userID_mark" style={{position: "absolute", top:"40px",right: "0px"}} class="fa-solid fa-eye" onClick={() => { this.markUserID() }}></i>
                  </div>
                </div>
                <div className="buttonContainer">
                  <button className="btn btn-primary round main" id="loginBtn" onClick={() => { this.loginSubmit() }}>登入</button>
                </div>
                <div className="loginHelper">
                  <a href="../OpenAcct" style={{display:"inline"}} target="_blank" rel="noopener noreferrer">尚未註冊</a>
                  ｜
                  <a href="../../EC/forgot-password" style={{display:"inline"}} target="_blank" rel="noopener noreferrer">忘記密碼</a>
                  ｜
                  <a href="../../EC/forgot-userID" style={{display:"inline"}} target="_blank" rel="noopener noreferrer">忘記代號</a>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
  }
}
function mapStateToProps(state) {
  return {
    isLogin: state.anueInfoState.isLogin
  };
}

export default connect(mapStateToProps, { loginApi, updatePwd, ChkAccessTkn })(withRouter(Login));
